import React, { useEffect, useRef, useState } from 'react'
import HeroParallax from '../../../components/Parallax/HeroParallax'
import '../../../../src/styles/tiktok.css'
import titleTiktok2026 from '../../../media/img/title-tiktok-2026.png'
import ringsPhoneTiktok from '../../../media/img/rings-phone-tiktok.png'
import spherePhoneTiktok from '../../../media/img/sphere-phone-tiktok.png'
import phoneTiktok from '../../../media/img/phone-tiktok.png'
import backDots from "../../../media/img/back-dots.png"
import backDotsTwo from "../../../media/img/back-dots-two.png"
import messageOne from "../../../media/svg/message-one.svg";
import messageTwo from "../../../media/svg/message-two.svg";
import messageThree from "../../../media/svg/message-three.svg";
import messageFour from "../../../media/svg/message-four.svg";
import circleBlueGreen from "../../../media/img/circle-blue-green.png";
import circleOrangePurple from "../../../media/img/circle-orange-purple.png";
import circleOrangePurpleTwo from "../../../media/img/circle-orange-purple-two.png";
import ringOpacity from "../../../media/img/ring-opacity.png";
import Anio2026Text from "../../../media/img/2026-text.png";
import shieldPerson from "../../../media/svg/shield-person.svg";
import balanceIcon from "../../../media/svg/balance-icon.svg";
import fingerprintLap from "../../../media/svg/fingerprint-lap.svg";
import fingerprintCell from "../../../media/svg/fingerprint-cell.svg";
import DateStepsView from './DateSteps/DateStepsView';
import Bases from './Bases/Bases';
import PremiosView from './premios/PremiosView';
import Contacto from './Contacto/Contacto';
import SocialMedia from './SocialMedia/SocialMedia';
import { Link } from 'react-router-dom';
import tiktokIcon from '../../../media/svg/tiktok-icon.svg'
import IntroductionComponent from './introduction/introduction';
import Tematicas from './tematicas/Tematicas';
import Videos from './videos/Main';
import Integrantes from './integrantes/Main';

import { useConcursoTikTok } from '../../../hooks/useConcursoTikTok2025';
import { base_url_completa } from '../../../constants';

const ConcursoTikTok = () => {


  const scrollRef = useRef<any>(null);
  const scrollRefBases = useRef<any>(null);
  const scrollRefPremios = useRef<any>(null);
  const scrollRefContacto = useRef<any>(null);
  const scrollRefIntroduccion = useRef<any>(null);
  const scrollRefTematicas = useRef<any>(null);
  const scrollRefVideos= useRef<any>(null);
  const scrollRefIntegrantes= useRef<any>(null);
  const { videos, getVideos} = useConcursoTikTok();

  useEffect(() => {
    getVideos(2026)
  }, [])
  async function _onClick(e: React.MouseEvent<HTMLAnchorElement>) {
    e.preventDefault()
    const obj = e.target as HTMLAnchorElement
    switch (obj.id) {
      case "etapas-fechas":
        scrollRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' }) 
        break
      case "bases":
        scrollRefBases.current.scrollIntoView({ behavior: 'smooth', block: 'start' }) 
        break
      case "premios":
          scrollRefPremios.current.scrollIntoView({ behavior: 'smooth', block: 'start' }) 
          break
      case "contacto":
        scrollRefContacto.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
          break
      case "introduccion":
        scrollRefIntroduccion.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
        break
      case "tematicas":
        scrollRefTematicas.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
        break
      case "videos":
        scrollRefVideos.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
        break
      case "integrantes":
        scrollRefIntegrantes.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
        break
      default:
        break;
    }
  }

  return (
    <div>
      <div className="" id="nav-float-left" style={{zIndex: '200'}}>
        <Link onClick={_onClick} to={"introduccion"} className="nav-link" aria-current="page" >
          <div className="nav-link-main">
            <div className="icon-nav-link">
              <img src={tiktokIcon} alt="tiktok" />
            </div>
            <p id='introduccion'>Introducción</p>
          </div>
        </Link>
        <Link onClick={_onClick} to={"tematicas"} className="nav-link" aria-current="page">
          <div className="nav-link-main">
            <div className="icon-nav-link">
              <img src={tiktokIcon} alt="tiktok" />
            </div>
            <p  id='tematicas'>Temáticas</p>
          </div>
        </Link>
        <Link onClick={_onClick} to={'etapas-fechas'} className="nav-link" aria-current="page" >
          <div className="nav-link-main">
            <div className="icon-nav-link">
              <img src={tiktokIcon} alt="tiktok" />
            </div>
            <p id='etapas-fechas'>Etapas y fechas</p>
          </div>
        </Link>
        <Link onClick={_onClick} to={'bases'} className="nav-link" aria-current="page" >
          <div className="nav-link-main">
            <div className="icon-nav-link">
              <img src={tiktokIcon} alt="tiktok" />
            </div>
            <p id='bases'>Bases</p>
          </div>
        </Link>
        <Link onClick={_onClick} to={'premios'} className="nav-link" aria-current="page" >
          <div className="nav-link-main">
            <div className="icon-nav-link">
              <img src={tiktokIcon} alt="tiktok" />
            </div>
            <p id='premios'>Premios</p>
          </div>
        </Link>
        { (Object.keys(videos).length === 0)?<></>:
        <Link onClick={_onClick} to={'videos'} className="nav-link" aria-current="page" >
          <div className="nav-link-main">
            <div className="icon-nav-link">
              <img src={tiktokIcon} alt="tiktok" />
            </div>
            <p id='videos'>Resultados</p>
          </div>
        </Link>}
        <Link onClick={_onClick} to={'integrantes'} className="nav-link" aria-current="page" >
          <div className="nav-link-main">
            <div className="icon-nav-link">
              <img src={tiktokIcon} alt="tiktok" />
            </div>
            <p id='integrantes'>Jurado Calificador</p>
          </div>
        </Link>
        <Link onClick={_onClick} to={'contacto'} className="nav-link" aria-current="page" >
          <div className="nav-link-main">
            <div className="icon-nav-link">
              <img src={tiktokIcon} alt="tiktok" />
            </div>
            <p id='contacto'>Contacto</p>
          </div>
        </Link>
      </div>
      <main id='main-container'>
        {/* <img src={backDots} alt="" id="dots-back-top" className="parallax-scroll" data-speed="-0.08"/>
        <img src={backDotsTwo} alt="" id="dots-back-bottom" className="parallax-scroll" data-speed="-0.1"/>
        <img src={backDotsTwo} alt="" id="dots-back-middle" className="parallax-scroll" data-speed="-0.2"/>
        <img src={messageOne} alt="mensaje uno" id="message-one" className="parallax-scroll" data-speed="0.18"/>
        <img src={messageTwo} alt="mensaje dos" id="message-two" className="parallax-scroll" data-speed="0.28"/>
        <img src={messageThree} alt="mensaje tres" id="message-three" className="parallax-scroll" data-speed="0.12"/>
        <img src={messageFour} alt="mensaje cuatro" id="message-four" className="parallax-scroll" data-speed="-0.15"/>
        <img src={circleBlueGreen} className="img-back-main parallax-scroll" id="circle-blue-green" alt="" data-speed="0.10"/>
        <img src={circleOrangePurple} className="img-back-main parallax-scroll" id="circle-orange-purple" alt="" data-speed="-0.12"/>
        <img src={circleOrangePurpleTwo} className="img-back-main parallax-scroll" id="circle-orange-purple-two" alt="" data-speed="-0.20"/>
        <img src={ringOpacity} className="img-back-main parallax-scroll" id="ring-opacity" alt="" data-speed="0.08"/>
        <img src={Anio2026Text} className="img-back-main parallax-scroll" id="anio-text" alt="" data-speed="0.16"/>
        <img src={shieldPerson} className="icon-white-fig parallax-scroll" id="shield-person" alt="" data-speed="-0.01"/>
        <img src={balanceIcon} className="icon-white-fig parallax-scroll" id="balance-icon" alt="" data-speed="-0.18"/>
        <img src={fingerprintLap} className="icon-white-fig parallax-scroll" id="fingerprint-lap" alt="" data-speed="0.12"/>
        <img src={fingerprintCell} className="icon-white-fig parallax-scroll" id="fingerprint-cell" alt="" data-speed="-0.2"/> */}
        <HeroParallax/>
        <div className="container-fluid" id="first-section-area">
          <div className="row row-height">
              <div className="col-12 container-phone-logo">
                  <div className="logo-tiktok-2026">
                    <div className="top-logo-tiktok">
                      <img src={titleTiktok2026} id="title-tiktok-2026" alt=""/>
                    </div>
                    <div className="bottom-logo-tiktok">
                      <div className="rings-wrapper">
                        <img src={ringsPhoneTiktok} id="rings-tiktok" alt="" />
                        <img src={spherePhoneTiktok} id="sphere-tiktok" alt="" />
                      </div>
                        <img src={phoneTiktok} id="phone-tiktok" alt="" />
                    </div>
                  </div>
              </div>
          </div>
        </div>
        <div ref={scrollRefIntroduccion}>
          <IntroductionComponent />
        </div>
        <div ref={scrollRefTematicas}>
          <Tematicas />
        </div>
        <div ref={scrollRef}>
          <DateStepsView />
        </div>
        <div ref={scrollRefBases}>
          <Bases/>
        </div>
        <div ref={scrollRefPremios}>
          <PremiosView/>
        </div>
        <div className="mt-5" ref={scrollRefVideos}>
          <div className="col-12 anchor-section"></div>
         { (Object.keys(videos).length === 0)?<></>:<Videos /> }
        </div>
        <div ref={scrollRefIntegrantes} className='mt-5'>
          <Integrantes/>
        </div>
        <div ref={scrollRefContacto}>    
        <Contacto/>
        </div>
        <SocialMedia/>
      </main>
    </div>
  )
}

export default ConcursoTikTok